<template>
  <div class="row">
    <div class="col-12 col-lg-6">
      <h5 class="card-title" v-if="type === 'event'">Wie heißt Ihre Veranstaltung?</h5>
      <h5 class="card-title" v-else>Wie heißt Ihr Objekt?</h5>
      <Field as="input" v-model="surveyStore.data.objektname" id="objektname" name="objektname" class="form-control" :class="{'is-invalid': errors.objektname}">
      </Field>
      <div v-if="errors.objektname" class="invalid-feedback">
        {{  errors.objektname }}
      </div>
    </div>
  </div>
</template>

<script>
import {useSurveyStore} from "@/stores/survey";
import {Field} from 'vee-validate';
export default {
  components: {
    Field,
  },
  setup() {
    return {
      surveyStore: useSurveyStore(),
    }
  },
  data() {
    return {

    }
  },
  props: {
    errors: Object,
    type: {
      default: 'object',
      type: String
    }
  },
  methods: {

  },

}
</script>
